import type { AuthPermissionUser } from '../../services/authPermissions';

// ORDER_STAFF = Handlowiec: supplier master data (decision 2026-09-23).
const SUPPLIER_MANAGEMENT_ROLES = ['MARKETING', 'ADMIN', 'OPERATIONS', 'ORDER_STAFF'];
// Mirrors backend SUPPLIER_DEFAULT_COST_MANAGEMENT_ROLES: supplier costs.
const SUPPLIER_DEFAULT_COST_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS'];

export function canManageSuppliers(user: AuthPermissionUser | null | undefined): boolean {
  return SUPPLIER_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canManageSupplierDefaultCosts(user: AuthPermissionUser | null | undefined): boolean {
  return SUPPLIER_DEFAULT_COST_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteSupplier(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}
